import { zoneList } from './fedexFicpZoneChart'
import { ficpRates } from './fedexFicpRatesChart'
import { fiepRates } from './fedexFieRatesChart'

export interface ZoneParamType {
	countryCode: string
	stateCode: string
	zip: string
}

export interface ShippingCostParamType extends ZoneParamType {
	width_cm: number
	height_cm: number
	depth_cm: number
}

export const Fedex = {
	getShippingCost: (params: ShippingCostParamType) => {
		const { countryCode, stateCode, zip, width_cm, height_cm, depth_cm } = params

		const zone = Fedex.getZone({
			countryCode: countryCode,
			stateCode: stateCode,
			zip: zip,
		})

		const rateList = zone.isAvailable
			? ficpRates[zone.exportCode]
			: fiepRates[zone.exportCode]

		const packageWeight: number =
			Math.round(((width_cm * height_cm * depth_cm) / 5000) * 2) / 2
		const rateKey: keyof typeof rateList = packageWeight.toFixed(
			1,
		) as keyof typeof rateList

		const rateKrw = rateList[rateKey]

		const res = {
			zone: zone,
			rateKrw: rateKrw,
		}

		return res
	},
	getZone: (params: ZoneParamType) => {
		const { countryCode, stateCode, zip } = params
		const idx = zoneList.findIndex(aZone => {
			if (countryCode === 'US') {
				const zoneZipMin = Number(aZone.zipMin)
				const zoneZipMax = Number(aZone.zipMax)

				if (
					aZone.countryCode === countryCode &&
					aZone.stateCode === stateCode &&
					Number(zip) >= zoneZipMin &&
					Number(zip) <= zoneZipMax
				) {
					return true
				} else if (aZone.countryCode === countryCode && aZone.stateCode === '') {
					return true
				}
			} else if (countryCode === 'CN') {
				const zoneZipMin = Number(aZone.zipMin)
				const zoneZipMax = Number(aZone.zipMax)

				if (
					aZone.countryCode === countryCode &&
					aZone.stateCode === stateCode &&
					Number(zip) >= zoneZipMin &&
					Number(zip) <= zoneZipMax
				) {
					return true
				} else if (aZone.countryCode === countryCode && aZone.stateCode === '') {
					return true
				}
			} else if (aZone.countryCode === countryCode) {
				return true
			}

			return false
		})

		return zoneList[idx]
	},
}
